module.exports = __webpack_public_path__ + "static/media/Card_TwelveWeek_en.2f225446.svg";